import * as Actions from '../../actions/actions';

const initialState = {
    studentSelectedSectionBeforeReview: {},
};

const dashboard = (state = initialState, action) => {
    switch (action.type) {
      case Actions.STUDENT_SELECTED_SECTION_BEFORE_REVIEW:
        return {
          ...state,
          studentSelectedSectionBeforeReview: action.data,
        };
  
      default:
        return state;
    }
  };
  export default dashboard;
  